module.exports = __webpack_public_path__ + "img/detect_not_cycle.0f1a8bed.png";